// // src/contexts/AuthContext.js
// import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import axios from 'axios';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(() => localStorage.getItem('token'));
//   const [loading, setLoading] = useState(true);

//   const logout = useCallback(() => {
//     if (user && user.id) {
//       localStorage.removeItem(`onboarding_video_seen_${user.id}`);
//       localStorage.removeItem(`onboarding_tour_seen_${user.id}`);
//     }
//     localStorage.removeItem('token');
//     setToken(null);
//     setUser(null);
//   }, [user]);

//   useEffect(() => {
//     if (token) {
//       localStorage.setItem('token', token);
//       axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

//       // Fetch fresh profile state to verify token validity
//       axios.get('/EOP_api/api/auth/me')
//         .then((res) => {
//           if (res.data && res.data.user) {
//             setUser(res.data.user);
//           } else {
//             logout();
//           }
//         })
//         .catch(() => {
//           logout();
//         })
//         .finally(() => {
//           setLoading(false);
//         });
//     } else {
//       delete axios.defaults.headers.common['Authorization'];
//       setUser(null);
//       setLoading(false);
//     }
//   }, [token, logout]);

//   const login = (jwtToken, userData) => {
//     setToken(jwtToken);
//     setUser(userData);
//   };

//   const hasRole = (roleIds) => {
//     if (!user) return false;
//     const rolesArray = Array.isArray(roleIds) ? roleIds : [roleIds];
//     return rolesArray.includes(parseInt(user.role_id));
//   };

//   return (
//     <AuthContext.Provider value={{ user, token, loading, login, logout, hasRole, setUser }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };








// src/contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    if (user && user.id) {
      localStorage.removeItem(`onboarding_video_seen_${user.id}`);
      localStorage.removeItem(`onboarding_tour_seen_${user.id}`);
      sessionStorage.removeItem(`onboarding_video_seen_${user.id}`);
    }
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  }, [user]);

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

      // Fetch fresh profile state to verify token validity
      axios.get('/EOP_api/api/auth/me')
        .then((res) => {
          if (res.data && res.data.user) {
            setUser(res.data.user);
          } else {
            logout();
          }
        })
        .catch(() => {
          logout();
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      delete axios.defaults.headers.common['Authorization'];
      setUser(null);
      setLoading(false);
    }
  }, [token, logout]);

  const login = (jwtToken, userData) => {
    setToken(jwtToken);
    setUser(userData);
  };

  const hasRole = (roleIds) => {
    if (!user) return false;
    const rolesArray = Array.isArray(roleIds) ? roleIds : [roleIds];
    return rolesArray.includes(parseInt(user.role_id));
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, hasRole, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
